export default "__VITE_ASSET__yx250OqC__"